/**
 * 海报组件
 */

 <template>
  <!-- 弹框海报 -->
  <AlertMenu ref="alertMenu">
    <div class="posterAlert" :style="`overflow:${is_loaded?'auto':'hidden'}`">
      <div class="posterAlert__example">
        <label class="posterAlert__text">海报模板:</label>
        <div class="posterAlert__thumbs">
          <img
            class="posterAlert__thumb"
            v-for="(item, index) in posters"
            :style="`background-image:url(${item.src})`"
            :key="index"
            @click="posterClick(item)"
          />
        </div>
      </div>
      <div class="posterAlert__own">
        <label class="posterAlert__text">我的专属海报:</label>
        <div class="posterView">
            <div class="posterView__posterWrapper" ref="poster" id="poster" :style="`height:${current_poster_height}px`" v-if="!is_loaded">
            <img class="posterAlert__own__bg" :src="current_poster_bg" :style="`width:100%; height:${current_poster_height}px`"/>
                <div class="posterView__qrcode" v-if="current_poster_bg">
                    <img class="posterView__qrcode__img" :src="qrcode_url" />
                    <span class="posterView__qrcode__title">{{qrcode_type === 'buy'?"立即扫码购课":"扫码领取试听课"}}</span>
                </div>
            </div>
            <img class="poster_url" :src="current_poster_url" />
        </div>
      </div>

      <div class="loading" v-if="loading">
          <span class="loading__text">正在加载...</span>
      </div>
    </div>
  </AlertMenu>
</template>
<script>
import AlertMenu from "./AlertMenu";
import { IMG_POSTER, DOM_TO_IMG } from "../common/Image";
import { Common } from '../common'
import { saveAs } from 'file-saver';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { types as AgentTypes } from "../store/modules/agentUser";


const POSTER_DATA = [
  "https://static1.bcjiaoyu.com/programMaMa/poster03.png-750x1335",
  "https://static1.bcjiaoyu.com/programMaMa/poster01.png-750x1335", 
  "https://static1.bcjiaoyu.com/programMaMa/poster02.png-750x1335",
  "https://static1.bcjiaoyu.com/programMaMa/poster04.png-750x1335",
  "https://static1.bcjiaoyu.com/programMaMa/poster05.png-750x1335", 
  "https://static1.bcjiaoyu.com/programMaMa/poster06.png-750x1335"
]

export default {
  name: "ChoosePoster",
  props:{
      agent_number:'',
  },
  components: {
    AlertMenu
  },
  data() {
    return {
      images: {
        posters: POSTER_DATA
      },
      loading: false,
      is_loaded:false,
      current_poster_bg: "",
      current_poster_url: "",
      current_poster_height:0,
      qrcode_url:'',
      qrcode_type:''
    };
  },
  computed: {
    ...mapState({
      posters: state => state.poster_data,
      temp_qrcode_url: state => state.agentUser.temp_qrcode_url
    })
  },
  watch:{
    temp_qrcode_url(item){
      this.qrcode_url = item;
      this.choosePosterBg(this.poster_example);
    }
  },
  created() {},
  mounted() {
  },
  methods: {
    ...mapActions({
      fetch_poster_qrcode: AgentTypes.FETCH_POSTER_QRCODE,
    }),
    show() {
        window.scroll(0, 0)
        this.$refs.alertMenu.show();
        this.loading = false;
        this.is_loaded = false;
        this.current_poster_bg = "";
        this.current_poster_url = "";
        this.current_poster_height = 0;
    },
    submitCallBack(){
        if(this.canvas){
            this.canvas.toBlob(function(blob){
                console.log(blob);
                saveAs(blob, "poster.png");
            })
        }
    },
    //海报点击事件
    posterClick(item){
      window.scroll(0, 0)
      this.is_loaded = false;
      this.loading = true;
      this.current_poster_url = "";
      this.current_poster_height = 0;
      this.current_poster_bg = item.src;

      let dic = {"agent_number":this.agent_number, "tag":item.tag}
      if(item.course_id){
        this.qrcode_type = 'buy'
        dic["course_id"] = item.course_id
      }else{
        this.qrcode_type = 'listen'
      }
      this.fetch_poster_qrcode(dic);
      this.poster_example = item.src;
    },
    //生成专属二维码
    choosePosterBg(item) {
      let this_ =this;
      // this.is_loaded = false;
      // this.loading = true;
      // this.current_poster_url = "";
      // this.current_poster_height = 0;
      // this.current_poster_bg = item;

      setTimeout(()=>{
        let width = this_.$refs.poster.clientWidth;
        console.log(width);

        Common.GET_PHOTO_WIDTH_HEIGHT(item, (w, h)=>{
          if(w == 0 || h == 0 ){
            w = 750;
            h = 1335;
          }
          this_.current_poster_height = width * h / w;
          this_.current_poster_width = width;
        });
      }, 500)

      setTimeout(() => {
        let ele = this_.$refs.poster;
        let scale = window.devicePixelRatio
        DOM_TO_IMG(ele, {
          height:this_.current_poster_height, 
          width:this_.current_poster_width, 
          scale:scale
        }, (url, canvas) => {
          console.log("海报好了");
          this_.current_poster_url = url;
          this_.loading = false;
          this_.is_loaded = true;
          this_.canvas = canvas;
        });
      }, 1000);
    }
  }
};
</script>
<style scoped>
.choosePoster{
    position: relative;
}
/**海报视图 */
.posterAlert {
  width: 510px;
  min-height: 200px;
  max-height: 600px;
  margin: 20px 0;
  overflow: auto;
}
.posterAlert__example {
}
.posterAlert__text {
  color: #333333;
  font-size: 14px;
  margin-bottom: 5px;
  display: inline-block;
}
.posterAlert__thumbs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: -10px;
}
.posterAlert__thumb {
  height: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  width: calc(100% / 6 - 10px);
  background-repeat: no-repeat;
  background-size: 100%;
}
.posterAlert__thumb--select {
}

.posterView{
    overflow: hidden;
    position: relative;
}
.posterView__posterWrapper{
    position: relative;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100%;
    overflow: hidden;
}
.posterView__qrcode {
  position: absolute;
  left: 0;
  bottom: 1.03%;
  width: 33.09%;
  height: 18.51%;

  font-size: 14px;
  color: #666666;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.posterView__qrcode__img {
  width: 140px;
  height: 140px;
  margin-bottom: 6px;
}
.poster_url {
    /* position: absolute;
    left: 0;
    top: 0;
    width: 100%; */

    display: block;
    width: 100%;
}

/***加载动画 */
.loading {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000001;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.loading__container {

}
.loading__img {
  vertical-align: middle;
  margin-right: 5px;
  width: 20px;
  height: 20px;
  display: inline-block;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA6CAMAAADbe8pdAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxRTRFRThFNTE4NDgxMUU4OENDOTlEMjdCMTVENzhDMiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxRTRFRThFNjE4NDgxMUU4OENDOTlEMjdCMTVENzhDMiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjFFNEVFOEUzMTg0ODExRTg4Q0M5OUQyN0IxNUQ3OEMyIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjFFNEVFOEU0MTg0ODExRTg4Q0M5OUQyN0IxNUQ3OEMyIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+7Ss/ewAAAFdQTFRF//Pm//jx/4QA/+7b/9mx/9Cd/9Wo/967/+nS/7x1/7Bb/+bL/8aJ/6tQ/6I//+LD/4sP/7hr/48W/8uU/8F+/4gI/5Mf/583/6dI/7Rj/5sv/5co////ZVMkcwAAAB10Uk5T/////////////////////////////////////wBZhudqAAABpUlEQVR42uzW6W7kIAwAYBPuG3JMkpm8/3OWtlLVLZC4s9JqK5Wfo/lkQ4wxHH+x4Bf/L5je0231M4NnMB/e12jY9zHJITzSm1/ZU3sGqe+v3AMGk/on6YtO4gqTln3l67AM7ioy6aWvi55PMSH9zYvla2xA25L6kgbZxeQcH2xII3TwlT0ONyymg+ESHyEtsYkJXFeMSsk3MQC5vkg5JdvAmMAl9Jh0AwMKH34MTUwweBpvscKE4pqKvY1ThQGJSRj10/gwo3ke55uvMMVi3cLqn+CHaWCKw/sj1weGxMQ/5hpbhaowFe68rjBrUZvm99XWta0sKu+8msbFoDEiLA2ra93nGBGhXQiq1UlUjJdHRreg2z1MSntZIdunwH90TyXlReJi21yv6UvJTj+X9d6QHgZ2qpUxm+2/VZSxvrbGeHb2SlLBhOrs1+xenL/PVAghG8GpM3s11lT/AyYEj18T4nk32SJmksjLYh/XhFA56Zz3iaCmIWBFTxMX5fgEd7Mu1in0KAVRTK6seS5Sayfo94Y4sFLwtw30y+533v4x+EWAAQD1Ql+vGKabYgAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
  background-position: -1px 0;
  background-size: contain;
  transform-origin: center center;
  animation-name: loading;
  animation-duration: 1.2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes loading {
  0% {
    -webkit-transform: rotate(0);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
